import _extends from "@babel/runtime/helpers/extends";
import _jsx from "@babel/runtime/helpers/jsx";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["isShown", "onClose", "submit", "isDeleting", "title", "description", "classes", "snackbarMessage", "onCloseSnackbar", "isDeleted", "deletingError", "deleteBtnLabel", "cancelBtnLabel", "deleteBtnId", "submitColor", "submitDisabled"];
var _dec, _dec2, _class, _class2;
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, injectIntl } from 'react-intl';
import noop from 'lodash/noop';
import muiWithStyles from '@mui/styles/withStyles';
import withStyles from 'isomorphic-style-loader/withStyles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import { Interweave } from 'interweave';
import NoSsr from '@mui/material/NoSsr';
import s from './ConfirmDeleteDialog.scss';
import intlPropTypes from '../../../constants/intlPropTypes';
var messages = defineMessages({
  cancelRemoveLabel: {
    id: "General.refuseDeleteBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Oops! no thanks"
    }]
  },
  deleteBtnLabel: {
    id: "General.deleteBtnLabel",
    defaultMessage: [{
      "type": 0,
      "value": "Delete"
    }]
  }
});
var styles = function styles(theme) {
  return {
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12
    },
    buttonWrapper: {
      margin: theme.spacing(1),
      position: 'relative'
    },
    buttonSuccess: {
      backgroundColor: green[500],
      color: '#fff',
      '&:hover': {
        backgroundColor: green[700],
        color: '#fff'
      }
    }
  };
};
var ConfirmDeleteDialog = (_dec = muiWithStyles(styles), _dec2 = withStyles(s), injectIntl(_class = _dec(_class = _dec2(_class = (_class2 = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ConfirmDeleteDialog, _React$PureComponent);
  var _super = _createSuper(ConfirmDeleteDialog);
  function ConfirmDeleteDialog() {
    _classCallCheck(this, ConfirmDeleteDialog);
    return _super.apply(this, arguments);
  }
  _createClass(ConfirmDeleteDialog, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        isShown = _this$props.isShown,
        onClose = _this$props.onClose,
        submit = _this$props.submit,
        isDeleting = _this$props.isDeleting,
        title = _this$props.title,
        description = _this$props.description,
        classes = _this$props.classes,
        snackbarMessage = _this$props.snackbarMessage,
        onCloseSnackbar = _this$props.onCloseSnackbar,
        isDeleted = _this$props.isDeleted,
        deletingError = _this$props.deletingError,
        deleteBtnLabel = _this$props.deleteBtnLabel,
        cancelBtnLabel = _this$props.cancelBtnLabel,
        deleteBtnId = _this$props.deleteBtnId,
        submitColor = _this$props.submitColor,
        submitDisabled = _this$props.submitDisabled,
        rest = _objectWithoutProperties(_this$props, _excluded);
      var message = deletingError || snackbarMessage;
      return /*#__PURE__*/_jsx("div", {}, void 0, /*#__PURE__*/React.createElement(Dialog, _extends({
        open: isShown,
        onClose: onClose,
        classes: {
          paper: s.dialog
        }
      }, rest), /*#__PURE__*/_jsx(DialogTitle, {
        classes: {
          root: s.dialogTitle
        }
      }, void 0, title), /*#__PURE__*/_jsx(DialogContent, {}, void 0, /*#__PURE__*/_jsx(DialogContentText, {
        component: "span"
      }, void 0, description)), /*#__PURE__*/_jsx(DialogActions, {}, void 0, /*#__PURE__*/_jsx(Button, {
        "data-test-id": "kfWSir0JmAKLtvagg_EkG",
        onClick: onClose,
        color: "primary",
        disabled: isDeleting
      }, void 0, cancelBtnLabel || /*#__PURE__*/React.createElement(FormattedMessage, messages.cancelRemoveLabel)), /*#__PURE__*/_jsx(Button, {
        "data-test-id": "nfFe30yS7BrocRIBcMy1R",
        onClick: submit,
        variant: "contained",
        color: submitColor,
        autoFocus: true,
        disabled: isDeleting || submitDisabled,
        id: deleteBtnId,
        className: classNames(_defineProperty({}, classes.buttonSuccess, isDeleted))
      }, void 0, isDeleting && /*#__PURE__*/_jsx(CircularProgress, {
        size: 25,
        className: classes.buttonProgress
      }), deleteBtnLabel || /*#__PURE__*/React.createElement(FormattedMessage, messages.deleteBtnLabel)))), /*#__PURE__*/_jsx(Snackbar, {
        open: (!!deletingError || isDeleted) && message,
        onClose: onCloseSnackbar,
        autoHideDuration: 2000,
        message: typeof message === 'string' ? /*#__PURE__*/_jsx(NoSsr, {}, void 0, /*#__PURE__*/_jsx(Interweave, {
          tagName: "div",
          content: message
        })) : message
      }));
    }
  }]);
  return ConfirmDeleteDialog;
}(React.PureComponent), _defineProperty(_class2, "defaultProps", {
  description: '',
  deletingError: '',
  deleteBtnLabel: null,
  cancelBtnLabel: null,
  deleteBtnId: '',
  submitColor: 'secondary',
  submitDisabled: false,
  snackbarMessage: '',
  onCloseSnackbar: noop,
  isDeleted: false,
  classes: {}
}), _class2)) || _class) || _class) || _class);
export { ConfirmDeleteDialog as default };